import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { WithStyles, createStyles } from "@material-ui/core";

const styles = createStyles({
  switch: {
    position: "relative",
    display: "inline-block",
    width: "60px",
    height: "25px",
    cursor: "pointer",
  },
  input: {
    opacity: 0,
    width: 0,
    height: 0,
  },
  slider: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "#ccc",
    borderRadius: "25px",
    transition: ".4s",
  },
  round: {
    position: "absolute",
    content: '""',
    height: "18px",
    width: "18px",
    left: "4px",
    bottom: "4px",
    borderRadius: "50%",
    backgroundColor: "white",
    transition: ".4s",
  },
  checkedSlider: {
    backgroundColor: "#2196F3",
  },
  checkedRound: {
    transform: "translateX(34px)",
  },
  focusedSlider: {
    boxShadow: "0 0 1px #2196F3",
  },
  disabled: {
    cursor: "not-allowed",
  },
  text: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    textAlign: "center",
    color: 'white',
    userSelect: "none",
    fontWeight: 700,
  },
  onText: {
    left: '5px',
  },
  offText: {
    right: '5px',
  },
});

interface ToggleInputProps extends WithStyles<typeof styles> {
  isChecked: boolean;
  handleToggle: Function;
  disabled?: boolean;
}

class ToggleInput extends Component<ToggleInputProps> {
  render() {
    const { classes, isChecked, handleToggle, disabled } = this.props;

    return (
      <div className={`${classes.switch}`}>
        <label className={`${classes.switch} ${classes.slider} ${isChecked ? classes.checkedSlider : ""} ${classes.focusedSlider} ${disabled ? classes.disabled : ""}`}>
          <input
            type="checkbox"
            className={classes.input}
            onChange={() => handleToggle(!isChecked)}
            disabled={disabled}
          />
          <div className={`${classes.round} ${isChecked ? classes.checkedRound : ""}`} />
          <div className={`${classes.text} ${classes.onText}`} style={{ visibility: isChecked ? "visible" : "hidden" }}>On</div>
          <div className={`${classes.text} ${classes.offText}`} style={{ visibility: isChecked ? "hidden" : "visible" }}>Off</div>
        </label>
      </div>
    );
  }
}

export default withStyles(styles)(ToggleInput);